module.exports = __webpack_public_path__ + "assets/fonts/a3a486be-4085-40f7-a7fa-4b19485d0653.7feda842.woff2";